import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b655ebf&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QTd,QBtn,QCard,QCardSection,QMenu,QList,QItem,QItemSection,QSeparator,QItemLabel,QIcon,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTr,QTh,QTd,QBtn,QCard,QCardSection,QMenu,QList,QItem,QItemSection,QSeparator,QItemLabel,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
